import React from "react";
import { Route, Routes} from "react-router-dom";
import NavBar from "./Navbar.js";
import Home from "./Home.js";
import Cardio from "./Cardio.js";
import Weight from "./Weight.js";
import Flexibility from "./Flexibility.js";
import Upload from "./Upload.js";
import Footer from "./Footer.js";
import Article from "./Article.js";

// function that allows you to click on the Scroll button to go down to the bottom of the page
export function handleScroll() {
  window.scroll({
    top: document.body.offsetHeight,
    left: 0, 
    behavior: 'smooth',
  });
}

//function that maps all existing cards to pages from db
export default function App() {
  return(
    <div className="font-link">
      <NavBar aria-label="NavBar"/>
      <Routes>
        <Route path="/" element={<Home />} aria-label="Home"/>
        <Route path="/Cardio" element={<Cardio />} aria-label="Cardio"/>
        <Route path="/Weight" element={<Weight />} aria-label="Weight"/>
        <Route path="/Flexibility" element={<Flexibility />} aria-label="Flexibility"/>
        <Route path="/Upload" element={<Upload />} aria-label="Upload"/>
        <Route path="/Article/:username" element={<Article />} />
      </Routes>
      <Footer />
    </div>
  );
}
